import { render, staticRenderFns } from "./gzdcjy.vue?vue&type=template&id=36891be8&scoped=true"
import script from "./gzdcjy.vue?vue&type=script&lang=js"
export * from "./gzdcjy.vue?vue&type=script&lang=js"
import style0 from "./gzdcjy.vue?vue&type=style&index=0&id=36891be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36891be8",
  null
  
)

export default component.exports